import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/utility/auth/auth.service';
import { 
	OrderRequestListComponent, 
	OrderRequestDetailComponent,
	OrderApproveComponent, 
	ProcessListComponent, 
	ProcessDetailComponent, 
	FormDetailComponent,
	FormListComponent,
	FormViewComponent
} from '@serengeti/serengeti-order';

const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: 'order/preview/list', component: FormListComponent, outlet: 'content', data: { title: 'lib.form.list.title', root: true } },
		{ path: 'order/preview/view/:id/', component: FormViewComponent, outlet: 'content', data: { title: 'lib.form.view.title' } },
		
		{ path: 'order/form/list', component: FormListComponent, outlet: 'content', data: { title: 'lib.form.list.title', root: true } },
		{ path: 'order/form/create', component: FormDetailComponent, outlet: 'content', data: { title: 'lib.form.create.title' } },
		{ path: 'order/form/detail/:id/', component: FormDetailComponent, outlet: 'content', data: { title: 'lib.form.detail.title' } },
		{ path: 'order/form/view/:id/', component: FormViewComponent, outlet: 'content', data: { title: 'lib.form.view.title' } },

		{ path: 'order/process/list', component: ProcessListComponent, outlet: 'content', data: { title: 'lib.process.list.title', root: true } },
		{ path: 'order/process/create', component: ProcessDetailComponent, outlet: 'content', data: { title: 'lib.process.create.title' } },
		{ path: 'order/process/detail/:id/', component: ProcessDetailComponent, outlet: 'content', data: { title: 'lib.process.detail.title' } },
		
		{ path: 'order/approve/list', component: OrderApproveComponent, outlet: 'content', data: { title: 'lib.order.approve.list.title', root: true } },
		{ path: 'order/request/list', component: OrderRequestListComponent, outlet: 'content', data: { title: 'lib.order.request.list.title', root: true } },
		{ path: 'order/request/detail/:id/', component: OrderRequestDetailComponent, outlet: 'content', data: { title: 'lib.order.request.detail.title' } }
	]},
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingOrderModule { }
